import { Link } from "react-router-dom";
import { specials } from "@/mocks/specials";
import { getMoviesBySpecial } from "@/utils/movie";

export default function SpecialPreview() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
      {specials.slice(0, 3).map((special) => {
        const count = getMoviesBySpecial(special.id).length;
        return (
          <Link
            key={special.id}
            to="/specials"
            className="group relative block h-56 overflow-hidden rounded-xl cursor-pointer"
          >
            <img
              src={special.cover}
              alt={special.title}
              title={`${special.title} 秋霞网专题`}
              className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary-950 via-secondary-950/60 to-secondary-950/10" />
            <div className="absolute inset-x-0 bottom-0 p-5">
              <span className="rounded bg-primary-500 px-2 py-0.5 text-[10px] font-medium text-foreground-950">
                专题合集 · {count} 部
              </span>
              <h3 className="mt-2 font-heading text-xl font-semibold text-foreground-950">
                {special.title}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs text-foreground-500">
                {special.description}
              </p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}